export const RESIDENTIAL_SEGMENT = 'residential'
export const SELF_EMPLOYED_SEGMENT = 'selfEmployed'
